import { useLazyQuery } from '@apollo/client';
import { SPOT_REVIEWS } from '../../graphql/spots.queries';

export default function useGetSpotReviews() {
    const [getSpotReviews, { data, loading }] = useLazyQuery(SPOT_REVIEWS);
    return { getSpotReviews, reviews: data?.dogParkOrSpot?.reviews, loading };
}
